export enum AuthenticationAttemptResult{
    Success = 'success',
    Blocked = 'blocked',
    InvalidCaptcha = 'captcha_required',
    CblcNotInformed = 'cblc_not_informed',
    SecondFactorRequired = 'second_factor_required',
    InvalidGrant = 'invalid_grant',//ok
    UserNotFound = 'usernotfound',
    TokenExpired = 'token_expired',
    TokenInvalid = 'token_invalid',
    TokenNotFound = 'token_not_foud',
    InvalidCredenntials = 'invalid_credentials',
    BiometricFacialRequired = 'biometric_facial_required',
}
